import { render, staticRenderFns } from "./GudangLayout.vue?vue&type=template&id=4dcd21ac&scoped=true&"
import script from "./GudangLayout.vue?vue&type=script&lang=js&"
export * from "./GudangLayout.vue?vue&type=script&lang=js&"
import style0 from "./GudangLayout.vue?vue&type=style&index=0&id=4dcd21ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcd21ac",
  null
  
)

export default component.exports